import { render } from "./home.vue?vue&type=template&id=45012044&scoped=true&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=45012044&lang=less&scoped=true"
import "./home.vue?vue&type=style&index=1&id=45012044&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45012044"]])

export default __exports__